import React, { Component } from 'react';
import { shape, string, number } from 'prop-types';
import { Form, Icon, Input } from 'semantic-ui-react';
import { DayPickerSingleDateController, CalendarDay } from 'react-dates';
import OutsideClickHandler from 'react-outside-click-handler';
import styles from './DatePickerSelection.less';

const formatValues = dates => dates.map(date => date.format('DD MMM YYYY')).join(', ');

class DatePickerSelectionField extends Component {
  static propTypes = {
    field: shape({}).isRequired,
    form: shape({}).isRequired,
    label: string.isRequired,
    placeholder: string,
    displayFormat: string,
    numberOfMonths: number,
  }

  static defaultProps = {
    placeholder: 'Select dates',
    numberOfMonths: 1,
    displayFormat: 'DD MMM YYYY',
  }

  state = {
    isOpenCalendar: false,
    focused: false,
  }

  openCalendar = () => {
    this.setState({ isOpenCalendar: true });
  }

  closeCalendar = () => {
    this.setState({ isOpenCalendar: false });
  }

  onDateChange = (date) => {
    const { field: { name, value = [] }, form: { setFieldValue } } = this.props;
    const newValues = value.find(item => item.isSame(date)) ? value.filter(d => !date.isSame(d)) : [...value, date];
    setFieldValue(name, newValues);
  }

  onFocusChange = ({ focused }) => {
    this.setState({ focused });
  }

  onOutsideClick = () => {
    this.setState({ isOpenCalendar: false });
  }

  render() {
    const {
      isOpenCalendar,
      focused,
    } = this.state;

    const {
      label,
      placeholder,
      field: { value, name },
      form: { touched, errors },
      numberOfMonths,
      ...rest
    } = this.props;
    return (
      <Form.Field error={touched[name] && errors[name]}>
        <span className={styles.label}>{label}</span>
        <OutsideClickHandler onOutsideClick={this.onOutsideClick}>
          <div className={styles.datePickerComponent}>
            <div className={styles.textValue}>
              <Input
                fluid
                placeholder={placeholder}
                icon={<Icon name="calendar alternate outline" link />}
                input={<input readOnly onClick={this.openCalendar} />}
                value={formatValues(value)}
              />
            </div>

            {
              isOpenCalendar
              && (
                <div style={{ position: 'absolute', paddingTop: '0.5rem', zIndex: 1 }}>
                  <DayPickerSingleDateController
                    numberOfMonths={numberOfMonths}
                    onDateChange={this.onDateChange}
                    focused={focused}
                    onFocusChange={this.onFocusChange}
                    renderCalendarDay={(props) => {
                      const { day, modifiers } = props;

                      if (value && value.find(item => item.isSame(day)) && modifiers) {
                        modifiers.add('selected');
                      } else if (modifiers) {
                        modifiers.delete('selected');
                      }

                      return (
                        <CalendarDay {...props} modifiers={modifiers} />
                      );
                    }}
                    {...rest}
                  />
                </div>
              )
            }
            {
              touched[name] && errors[name] && (
                <span className={styles.error}>{errors[name]}</span>
              )
            }
          </div>
        </OutsideClickHandler>
      </Form.Field>
    );
  }
}

export default DatePickerSelectionField;
